import styled from 'styled-components';
import {transparentize} from 'polished';

export const Types = styled.div`
  margin: 8px 0;
  column-gap: 10px;
  align-content: center;
  grid-auto-flow: column;
  display: inline-grid;
`;

export const TotalScore = styled.p`
  margin: 8px 0;
  &:after {
    content: "= 100%";
    margin-left: 6px;
    color: ${({theme}) => `
      ${transparentize(.6, theme.variables.color)};
    `};
  }
`;

export const Note = styled.p`
  margin: 0;
  line-height: 16px;
  font-size: 12px;
  color: ${({theme}) => `
    ${transparentize(.6, theme.variables.color)};
  `};
`;
